import { render } from "./Textarea.vue?vue&type=template&id=5aaff71b&scoped=true"
import script from "./Textarea.vue?vue&type=script&lang=js"
export * from "./Textarea.vue?vue&type=script&lang=js"

import "./Textarea.vue?vue&type=style&index=0&id=5aaff71b&lang=less&scoped=true"

import exportComponent from "/builds/maizhensheng/app-commonapply-v6/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aaff71b"]])

export default __exports__